import { Select as MuiSelect } from "@mui/material";
import { styled } from "@mui/material/styles";

const Select = styled(MuiSelect)(({ styles }) => ({
  backgroundColor: "var(--input-primary-bg)",
  color: "var(--input-primary-text)",

  "&.MuiList-root": {
    backgroundColor: "var(--container-light)",
  },

  "&:hover": {
    backgroundColor: "var(--input-primary-bg)",
    color: "var(--input-primary-text)",
  },

  "&:after": {
    borderBottomColor: "var(--input-primary-text)",
  },

  ...styles,
}));

export default Select;
